import { QRCodeSVG } from "qrcode.react";
import { TackLogo } from "@/components/TackLogo";

export function PosterCard({
  posterRef,
  primaryColor,
  feedbackUrl,
  topText,
  bottomText,
  merchantName,
}: {
  posterRef?: React.RefObject<HTMLDivElement | null>;
  primaryColor: string;
  feedbackUrl: string;
  topText: string;
  bottomText: string;
  merchantName?: string;
}) {
  return (
    <div
      ref={posterRef}
      className="poster-card shadow-xl flex-shrink-0"
      style={{
        width: 595,
        height: 842,
        backgroundColor: "#FAF8F5",
        fontFamily: "'DM Sans', sans-serif",
        padding: 24,
        boxSizing: "border-box",
      }}
    >
      <div
        className="flex flex-col items-center"
        style={{
          border: `2px solid ${primaryColor}`,
          borderRadius: 12,
          padding: "40px 50px 40px",
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          position: "relative",
        }}
      >
        {/* Top: Tack branding */}
        <div className="flex flex-col items-center text-center" style={{ marginTop: -12 }}>
          <TackLogo size="xl" />
          <p
            style={{
              fontSize: 22,
              marginTop: 12,
              letterSpacing: "0.08em",
              color: "#707A8A",
            }}
          >
            {topText}
          </p>
        </div>

        <div style={{ flex: 1 }} />

        {/* Center: QR with heart background */}
        <div
          className="relative flex items-center justify-center"
          style={{ marginTop: 70 }}
        >
          <svg
            viewBox="0 0 300 280"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -44.5%)",
              width: 567,
              height: 567,
            }}
          >
            <path
              d="M150 250 C150 250 30 170 30 100 C30 55 65 25 105 25 C130 25 148 42 150 45 C152 42 170 25 195 25 C235 25 270 55 270 100 C270 170 150 250 150 250Z"
              fill={primaryColor}
              fillOpacity={0.12}
              stroke={primaryColor}
              strokeWidth={1}
            />
          </svg>
          <div
            className="relative rounded-xl"
            style={{ padding: 16, zIndex: 1, border: `1px solid ${primaryColor}`, backgroundColor: "#ffffff" }}
          >
            <QRCodeSVG value={feedbackUrl} size={220} level="M" />
          </div>
        </div>

        <div style={{ flex: 1 }} />

        {/* CTA — fixed-height slot so wrapping doesn't shift QR position */}
        <div
          className="text-center"
          style={{
            marginTop: 80,
            height: 120,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <p
            style={{
              fontSize: 22,
              letterSpacing: "0.06em",
              lineHeight: 1.4,
              color: "#707A8A",
              margin: 0,
              whiteSpace: "normal",
            }}
          >
            {bottomText}
          </p>
        </div>

        <div style={{ flex: 0.6 }} />

        {/* Footer */}
        <div className="w-full flex justify-between items-center gap-2">
          <span style={{ fontSize: 15, color: "#707A8A", opacity: 0.75, fontWeight: 500 }}>
            {merchantName ?? ""}
          </span>
          <div className="flex items-center gap-2">
            <span style={{ fontSize: 12, color: "#707A8A" }}>Powered by</span>
            <TackLogo size="sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
